import * as actions from '../constants/actions';

const initialState = {
	authenticated: false,
	tokenData: null,
	scriptsLoaded: false,
	identityConfirmed: false,
	runtimeInitialized: false,
	params: null,
	error: null,
	supportedBrowser: true,
	legacyBrowser: false,
	supportedPlatform: true,
	browserInfo: null,
	osInfo: null,
	userProducts: null,
	productSelected: false,
	selectedProduct: null,
	studentName: null,
	version: "",
	imlp: true
};

export default (state = initialState, action) => {
	switch (action.type) {
		case actions.APP_INIT:
			const {
				params = {},
				supportedBrowser = true,
				legacyBrowser = false,
				supportedPlatform = true,
				browserInfo,
				osInfo
			} =
				action.payload || {};
			return {
				...state,
				params,
				supportedBrowser,
				legacyBrowser,
				supportedPlatform,
				browserInfo,
				osInfo
			};

		case actions.APP_USER_PRODUCTS:
			return {
				...state,
				userProducts: action.payload
			};

		case actions.APP_PRODUCT_SELECTED:
			return {
				...state,
				productSelected: true
			};

		case actions.APP_SELECTED_PRODUCT:
			return {
				...state,
				selectedProduct: action.payload
			};

		case action.APP_CLEARED_PRODUCT:
			return {
				...state,
				selectedProduct: null
			};

		case actions.APP_STUDENT_NAME:
			return {
				...state,
				studentName: action.payload
			};

		case actions.APP_STUDENT_SITECODE:
			return {
				...state,
				studentSiteCode: action.payload
			}

		case actions.APP_AUTHENTICATED:
			return {
				...state,
				authenticated: true,
				tokenData: action.payload.accessToken,
				idTokenData: action.payload.idToken
			};

		case actions.APP_AUTHTYPE_SET:
			return {
				...state,
				imlp: action.payload
			}

		case actions.APP_ERROR:
			return {
				...state,
				error: action.payload
			};

		case actions.APP_KEYDOWN: {
			let newState = {
				...state
			};
			return newState;
		}

		case actions.APP_KEYUP: {
			let newState = {
				...state
			};
			return newState;
		}

		case actions.APP_LOADED_SITECODE: {
			// If sitecode is already set, just ignore this
			if (state.params && state.params.sitecode) {
				return state;
			}
			const sitecode = action.payload;
			const params = state.params
				? {
						...state.params,
						sitecode
					}
				: { sitecode };
			return {
				...state,
				params
			};
		}

		case actions.APP_OVERRIDE_SUPPORTED_BROWSER:
			return {
				...state,
				supportedBrowser: true
			};

		case actions.APP_RUNTIME_INITIALIZED:
			return {
				...state,
				runtimeInitialized: true
			};

		case actions.APP_SCRIPTS_LOADED:
			return {
				...state,
				scriptsLoaded: true
			};

		case actions.APP_WARP:
			return {
				...state,
				authenticated: true
			};

		case actions.APP_VERSION_RECEIVED:
			return {
				...state,
				version: action.payload
			};

		case actions.APP_IDENTITY_CONFIRMED:
			return{
				...state,
				identityConfirmed: true
			}

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/app.js